module.exports = __webpack_public_path__ + "static/img/AtWuhu-4.874267ee.jpg";